// extracted by mini-css-extract-plugin
module.exports = {"ImgTeaser":"swipernft_ImgTeaser__1b8py","Card":"swipernft_Card__2f1Y5","SwiperContainer":"swipernft_SwiperContainer__cXGaL"};